import React, { useState, useEffect } from "react";
import "./timeseries.css";
import Select from "react-select";
import axios from "axios";
import CanvasJSReact from './../../../../../libs/canvasjs/canvasjs.react.js';
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

function Timeseries() {
  let data = [];
  let dataSeries1 = {
      type: "area",
      fillOpacity:.3
  };

  let dataSeries2 = {
      type: "line"
  };

   let dataPoints1 = [{ x: 1,  y: 10  },
   { x: 2, y: 15  },
   { x: 3, y: 25  },
   { x: 4,  y: 30  },
   { x: 5,  y: 28  }];
   let dataPoints2 = [{ x: 1,  y: 22  },
   { x: 2, y: 25  },
   { x: 3, y: 15  },
   { x: 4,  y: 10  },
   { x: 5,  y: 18  }];

   dataSeries1.dataPoints = dataPoints1;
   dataSeries2.dataPoints = dataPoints2;
   data.push(dataSeries1,dataSeries2);

   const options = {
       zoomEnabled: true,
       animationEnabled: true,
       title: {
           text: "Timeseries"
       },
       axisY: {
           lineThickness: 1
       },
       data: data
   };


   return (
      <div>
        <CanvasJSChart options = {options}
        />
      </div>
    );
}

export default Timeseries;
